import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from './constants-enumerate';
import {deepAssign} from '@aofl/object-utils';
const DEFAULT_PENDING_FILTERS = {
  group_path: [],
};

const sdo = {
  namespace: sdoNs.GROUP_SEARCH,
  mutations: {
    init() {
      return {
        level: 0,
        queryObj: {
          search: {},
          filters: {},
          sort: {},
          selection_mode: null,
          persistent_selection: [],
          not_selected: [],
          total_results: 0
        },
        results: [],
        hasMore: false,
        tableConfig: [],
        allSelected: false,
        selected: [],
        selectionMode: null,
        searchTargetUrl: '',
        profileTargetUrl: '',
        defaultQueryObj: {},
        pendingFilters: DEFAULT_PENDING_FILTERS
      };
    },
    setQuerySearchQuery(subState, query) {
      query = query.replace(/\s+/g, ' ');
      return deepAssign(subState, 'queryObj.search', {
        query
      });
    },
    setQuerySearchField(subState, field) {
      return deepAssign(subState, 'queryObj.search', {
        field
      });
    },
    setQuerySortFields(subState, field) {
      return deepAssign(subState, 'queryObj.sort', {
        fields: [field, 'id']
      });
    },
    setQueryFilters(subState, filters) {
      return deepAssign(subState, 'queryObj', {
        filters
      });
    },
    setPendingFilters(subState, _pendingFilters) {
      const pendingFilters = {
        ...DEFAULT_PENDING_FILTERS,
        ..._pendingFilters
      };
      return deepAssign(subState, '', {
        pendingFilters
      });
    },
    setPendingFiltersGroupPath(subState, path) {
      return deepAssign(subState, 'pendingFilters', {
        group_path: path
      });
    },
    setPendingFiltersClassesPath(subState, path) {
      return deepAssign(subState, 'pendingFilters', {
        classes_path: path
      });
    },
    setPendingFiltersClassroomId(subState, id) {
      return deepAssign(subState, 'pendingFilters', {
        classroom_id: id
      });
    },
    setPendingFiltersParentGroupId(subState, parentGroupId) {
      return deepAssign(subState, 'pendingFilters', {
        parent_group_id: parentGroupId
      });
    },
    updateSortOrder(subState, {index, field}) {
      let direction = subState.queryObj.sort.direction;
      if (direction === 'asc') {
        direction = 'desc';
      } else if (direction === 'desc') {
        direction = '';
      } else {
        direction = 'asc';
      }

      let fields = [field, 'id'];
      if (direction === '') fields = ['id'];

      return deepAssign(subState, 'queryObj.sort', {
        direction,
        fields
      });
    },
    removeSortLastValues(subState) {
      const nextSubState = deepAssign(subState, 'queryObj.sort', {});

      nextSubState.queryObj.sort.is_forward = true;
      if (typeof nextSubState.queryObj.sort.last_values !== 'undefined') {
        delete nextSubState.queryObj.sort.last_values;
      }

      return nextSubState;
    },
    select(subState, {id}) {
      const index = subState.selected.indexOf(id);
      if (index === -1) {
        subState = Object.assign({}, subState, {
          selected: [
            ...subState.selected,
            id
          ]
        });
      }
      if (subState.queryObj.persistent_selection.indexOf(id) === -1 && subState.queryObj.selection_mode !== 'all') {
        subState.queryObj.persistent_selection.push(id);
      }

      const indexNotSelected = subState.queryObj.not_selected.indexOf(id);
      if (indexNotSelected !== -1) {
        subState.queryObj.not_selected = [
          ...subState.queryObj.not_selected.slice(0, indexNotSelected),
          ...subState.queryObj.not_selected.slice(indexNotSelected + 1)
        ];
      }

      return subState;
    },
    selectAll(subState, {selectionMode}) {
      let newSubState = Object.assign({}, subState);
      newSubState.queryObj.selection_mode = selectionMode;
      for (let i = 0; i < subState.results.length; i++) {
        newSubState = sdo.mutations.select(newSubState, {id: subState.results[i].id});
      }
      if (selectionMode === 'all') {
        newSubState.queryObj.persistent_selection = [];
      }
      return newSubState;
    },
    selectPage(subState, {selectionMode}) {
      return this.selectAll(subState, {selectionMode});
    },
    deselect(subState, {id}) {
      const index = subState.selected.indexOf(id);
      if (index > -1) {
        subState = Object.assign({}, subState, {
          selected: [
            ...subState.selected.slice(0, index),
            ...subState.selected.slice(index + 1)
          ]
        });
      }

      const persistentSelectionIndex = subState.queryObj.persistent_selection.indexOf(id);
      if (persistentSelectionIndex > -1) {
        subState.queryObj.persistent_selection = [
          ...subState.queryObj.persistent_selection.slice(0, persistentSelectionIndex),
          ...subState.queryObj.persistent_selection.slice(persistentSelectionIndex + 1)
        ];
      }

      if (subState.queryObj.selection_mode === 'all' && subState.queryObj.not_selected.indexOf(id) === -1) {
        subState.queryObj.not_selected.push(id);
      }

      return subState;
    },
    deselectAll(subState) {
      let newSubState = Object.assign({}, subState);
      newSubState.queryObj.selection_mode = null;
      newSubState.queryObj.persistent_selection = [];
      newSubState.queryObj.not_selected = [];
      newSubState.selected = [];
      return Object.assign({}, subState, newSubState);
    },
    persistentSelection(subState) {
      let newSubState = Object.assign({}, subState);
      for (let i = 0; i < subState.queryObj.persistent_selection.length; i++) {
        newSubState = sdo.mutations.select(newSubState, {id: subState.queryObj.persistent_selection[i]});
      }
      return newSubState;
    }
  },
  decorators: [
    (nextState) => { // prev search query
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.GROUP_SEARCH];
      const subState = state[sdoNs.GROUP_SEARCH];

      if (typeof nextSubState.$prevQueryObj === 'undefined' || nextSubState.queryObj !== subState.queryObj) {
        const $prevQueryObj = subState.queryObj;

        nextState = deepAssign(nextState, `${sdoNs.GROUP_SEARCH}`, {$prevQueryObj});
      }

      return nextState;
    },
    (nextState) => { // prev pointer items
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.GROUP_SEARCH];
      const subState = state[sdoNs.GROUP_SEARCH];

      if (typeof nextSubState.$prev === 'undefined' || nextSubState.results !== subState.results) {
        let $prev = '';
        if (nextSubState.results.length > 0) {
          $prev = nextSubState.results[0]; /** @todo assign needed props */
        }

        nextState = deepAssign(nextState, `${sdoNs.GROUP_SEARCH}`, {$prev});
      }

      return nextState;
    },
    (nextState) => { // next pointer items
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.GROUP_SEARCH];
      const subState = state[sdoNs.GROUP_SEARCH];

      if (typeof nextSubState.$next === 'undefined' ||
      nextSubState.results !== subState.results) {
        let $next = '';
        if (nextSubState.results.length > 0) {
          $next = nextSubState.results[nextSubState.results.length - 1]; /** @todo assign needed props */
        }

        nextState = deepAssign(nextState, `${sdoNs.GROUP_SEARCH}`, {$next});
      }

      return nextState;
    },
    (nextState) => { // set results[].{$selected}
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.GROUP_SEARCH];
      const subState = state[sdoNs.GROUP_SEARCH];
      if (nextSubState.results !== subState.results ||
          nextSubState.selected !== subState.selected ||
          nextSubState.queryObj.selection_mode !== subState.queryObj.selection_mode) {
        const results = [];
        for (let i = 0; i < nextSubState.results.length; i++) {
          const group = nextSubState.results[i];
          if (nextSubState.selected.indexOf(group.id) !== -1 || nextSubState.queryObj.selection_mode === 'all') {
            let isSelected = true;
            if (nextSubState.queryObj.not_selected.indexOf(group.id) > -1) {
              isSelected = false;
            }
            results.push(Object.assign({}, group, {
              $selected: isSelected
            }));
          } else if (group.$selected === true) {
            results.push(Object.assign({}, group, {
              $selected: false
            }));
          } else {
            results.push(group);
          }
        }

        nextState = deepAssign(nextState, `${sdoNs.GROUP_SEARCH}`, {results});
      }

      return nextState;
    },
    (nextState) => { // $search to make api call
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.GROUP_SEARCH];
      const subState = state[sdoNs.GROUP_SEARCH];

      if (typeof nextSubState.$search === 'undefined' ||
      nextSubState.queryObj.search !== subState.queryObj.search) {
        let $search = void 0;

        if (nextSubState.queryObj.search.query && nextSubState.queryObj.search.query !== '') {
          $search = Object.assign({}, nextSubState.queryObj.search);
        }

        nextState = deepAssign(nextState, sdoNs.GROUP_SEARCH, {
          $search
        });
      }

      return nextState;
    },
    (nextState) => { // $selectedGroups
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.GROUP_SEARCH];
      const subState = state[sdoNs.GROUP_SEARCH];
      if (
        typeof nextSubState.$selectedGroups === 'undefined' ||
        nextSubState.queryObj.filters?.parent_group_id !== subState.queryObj.filters?.parent_group_id ||
        nextSubState.queryObj.filters?.classes_path !== subState.queryObj.filters?.classes_path

      ) {
        let $selectedGroups = [];
        if (
          Array.isArray(nextSubState.queryObj.filters?.parent_group_id) &&
          nextSubState.queryObj.filters?.parent_group_id.length
        ) {
          $selectedGroups = nextSubState.queryObj.filters?.parent_group_id.slice(nextState[sdoNs.SESSION].group_info.level);
        } else if (Array.isArray(nextSubState.queryObj.filters?.classes_path) &&
          nextSubState.queryObj.filters?.classes_path.length) {
          $selectedGroups = nextSubState.queryObj.filters?.classes_path;
        }
        nextState = deepAssign(nextState, sdoNs.GROUP_SEARCH, {
          $selectedGroups
        });
      }
      return nextState;
    },
    (nextState) => { // $filters to make api call
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.GROUP_SEARCH];
      const subState = state[sdoNs.GROUP_SEARCH];

      if (typeof nextSubState.$filters === 'undefined' ||
      nextSubState.queryObj.filters !== subState.queryObj.filters) {
        let $filters = Object.assign({}, nextSubState.queryObj.filters);
        if (Array.isArray($filters.parent_group_id) && $filters.parent_group_id.length > 0) {
          $filters = Object.assign({}, $filters, {
            parent_group_id: $filters.parent_group_id[$filters.parent_group_id.length - 1]
          });
        } else if (Array.isArray($filters.group_path) && $filters.group_path.length > 0) {
          $filters = Object.assign({}, $filters, {
            group_path: $filters.group_path[$filters.group_path.length - 1] || ''
          });
        } else if (Array.isArray($filters.classes_path)) {
          const path = nextSubState.queryObj.filters.classes_path;
          let newPath = nextState[sdoNs.SESSION].group_info.path + nextState[sdoNs.SESSION].group_info.id + '.';
          if (!newPath.includes(path.join('.'))) {
            newPath = nextState[sdoNs.SESSION].group_info.path + nextState[sdoNs.SESSION].group_info.id + '.' + path.join('.') + '.';
          }
          $filters = Object.assign({}, $filters, {
            path: newPath
          });
          delete $filters.classes_path;
        } else {
          delete $filters.parent_group_id;
          delete $filters.group_path;
        }
        if (typeof $filters.group_path === 'object') {
          delete $filters.group_path;
        }
        nextState = deepAssign(nextState, sdoNs.GROUP_SEARCH, {
          $filters
        });
      }

      return nextState;
    },
    (nextState) => { // $filterClassesPath
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.GROUP_SEARCH];
      const subState = state[sdoNs.GROUP_SEARCH];

      if (typeof nextSubState.$filterClassesPath === 'undefined' ||
      nextSubState.pendingFilters.classes_path !== subState.pendingFilters.classes_path) {
        let $filterClassesPath = [];
        if (Array.isArray(nextSubState.pendingFilters.classes_path) &&
        nextSubState.pendingFilters.classes_path.length > 1) {
          $filterClassesPath = nextSubState.pendingFilters.classes_path
            .slice(0, nextSubState.pendingFilters.classes_path.length - 1);
        }
        nextState = deepAssign(nextState, sdoNs.GROUP_SEARCH, {$filterClassesPath});
      }
      return nextState;
    },
    (nextState) => { // $sort to make api call
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.GROUP_SEARCH];
      const subState = state[sdoNs.GROUP_SEARCH];

      if (typeof nextSubState.$sort === 'undefined' ||
        nextSubState.queryObj.sort !== subState.queryObj.sort) {
        const $sort = Object.assign({}, nextSubState.queryObj.sort);
        if ($sort.direction === '') {
          $sort.direction = 'asc';
        }

        nextState = deepAssign(nextState, sdoNs.GROUP_SEARCH, {
          $sort
        });
      }

      return nextState;
    },
    (nextState) => { // $filtered results
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.GROUP_SEARCH];
      const subState = state[sdoNs.GROUP_SEARCH];

      if (typeof nextSubState.$filtered === 'undefined' ||
      nextSubState.queryObj.filters !== subState.queryObj.filters||
      nextState[sdoNs.SESSION].group_info.path !== state[sdoNs.SESSION].group_info.path) {
        let $filtered = false;
        if (typeof nextSubState.$filters.level !== 'undefined') {
          if (Object.keys(nextSubState.$filters).length > 1) {
            $filtered = true;
          }
        } else if (typeof nextSubState.$filters.path !== 'undefined') {
          if (nextSubState.$filters.path !== nextState[sdoNs.SESSION].group_info.path) {
            $filtered = true;
          }
        }

        nextState = deepAssign(nextState, sdoNs.GROUP_SEARCH, {
          $filtered
        });
      }

      return nextState;
    },
    (nextState) => { // $pageNumber
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.GROUP_SEARCH];
      const subState = state[sdoNs.GROUP_SEARCH];

      if (
        typeof nextSubState.$pageNumber === 'undefined'
        ||
        nextSubState.hasMore !== subState.hasMore
        ||
        nextSubState.$sort !== subState.$sort
      ) {
        const hasOffset = Boolean(nextSubState.$sort.last_values);
        let $pageNumber = 1;
        let $numPages = 3;

        if (nextSubState.$sort.is_forward) {
          if (hasOffset) {
            $pageNumber = 2;
          }

          if (!nextSubState.hasMore) {
            $numPages = $pageNumber;
          }
        } else {
          $pageNumber = nextSubState.hasMore ? 2 : 1;
        }

        nextState = deepAssign(nextState, `${sdoNs.GROUP_SEARCH}`, {$pageNumber, $numPages});
      }

      return nextState;
    },
    (nextState) => { // $selectedResults
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.GROUP_SEARCH];
      const subState = state[sdoNs.GROUP_SEARCH];

      if (typeof nextSubState.$selectedResults === 'undefined' ||
      nextSubState.selected !== subState.selected ||
      nextSubState.results !== subState.results) {
        const $selectedResults = nextSubState.results.filter((res) => nextSubState.selected.indexOf(res.id) > -1);
        nextState = deepAssign(nextState, sdoNs.GROUP_SEARCH, {$selectedResults});
      }

      return nextState;
    }
  ]
};

storeInstance.addState(sdo);
